<template>
    <modal size="medium" :no-footer="true" @close="$emit('close')">
        <template slot="header">
            Load data from Zoho CRM
        </template>

        <template slot="content">
            <p>Enter a facility number to load their data from Zoho CRM.</p>

            <div>
                <label>
                    <span>Facility Number</span>

                    <form class="flex ai-c jc-sb" @submit.prevent="onFormSubmit">
                        <input :disabled="is_loading" type="text" required v-model="facility_number" />

                        <button type="submit" class="ml-3">Search</button>
                    </form>
                </label>
            </div>

            <hr />

            <div v-if="is_loading">
                Loading facility...
            </div>

            <div v-else-if="error_message.length !== 0" class="danger-text">
                {{ error_message }}
            </div>

            <div v-else-if="facilities.length > 0">
                <div class="mb-3" v-if="facilities.length === 1">Found 1 facility:</div>
                <div class="mb-3" v-else>Found {{ facilities.length }} facilities:</div>

                <div v-for="facility in facilities" :key="`zoho-facility-${facility.Facility_Number}`" class="facility">
                    <div class="flex fw-w">
                        <div class="flex-50">
                            <strong class="mr-1">Facility Number:</strong>
                            <span>{{ facility.Facility_Number }}</span>
                        </div>

                        <div class="flex-50">
                            <strong class="mr-1">Account Name:</strong>
                            <span>{{ facility.Account_Name }}</span>
                        </div>

                        <div class="mt-2 flex-50">
                            <div class="flex">
                                <strong class="mr-1">Address:</strong>

                                <div>
                                    <div>{{ facility.Address }}</div>
                                    <div>{{ facility.Address_2 }}</div>
                                    <div>{{ facility.City }}, {{ facility.State }} {{ facility.ZIP_Code }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-2 flex-50">
                            <div class="flex">
                                <strong class="mr-1">Primary Contact:</strong>

                                <div v-if="facility.Property_Mgr || facility.Site_Email">
                                    <div>{{ facility.Property_Mgr }}</div>
                                    <div>{{ facility.Site_Email }}</div>
                                </div>

                                <div v-else class="gray-message">--</div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-3 flex ai-c jc-sb">
                        <a :href="`https://crm.zoho.com/crm/org6278647/tab/Accounts/${facility.id}`" class="button secondary" target="_blank">
                            <i class="material-icons">launch</i>

                            <span class="ml-1">See in Zoho CRM</span>
                        </a>

                        <button class="primary" type="button" @click="onSelectFacility(facility)">
                            <i class="material-icons">done</i>

                            <span class="ml-1">Use facility data</span>
                        </button>
                    </div>
                </div>
            </div>

            <div v-else class="gray-message">
                <i class="material-icons">info</i>

                <span class="ml-1">Facility data will be shown here.</span>
            </div>
        </template>
    </modal>
</template>

<script>
import http from "@/http"

export default {
    name: "load-from-zoho-modal",

    data () {
        return {
            error_message: "",
            facility_number: "",
            facilities: [],
            is_loading: false
        }
    },

    methods: {
        async onFormSubmit () {
            this.is_loading = true
            this.error_message = ""

            try {
                const { data } = await http("/api/facilities/from-zoho", { params: {
                    facility_number: this.facility_number
                } })

                this.facilities = data.data
            } catch (ex) {
                if (ex.message) {
                    this.error_message = ex
                } else {
                    this.error_message = ex
                }
            } finally {
                this.is_loading = false
            }
        },

        onSelectFacility (facility) {
            this.$emit("loaded", facility)
            this.$emit("close")
        }
    }
}
</script>

<style scoped>
.facility {
    border: 1px solid #cecece;
    box-shadow: 0px 0px 5px 0px #bfbfbf;
    padding: 15px;
}

.facility + .facility {
    margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/add-facility-page/LoadFromZohoModal.vue